// components/MultiPlatformPixelScript/metaSdk.ts — fbq loader (stub-aman)
// Delegasi ke satu pintu utils/pixelGate.ts. API dipertahankan untuk metaPixel.
import { ensureFbq as ensureFbqShared, isRealFbq } from '../../utils/pixelGate';

export function ensureFbq(logPrefix: string): () => boolean {
    if (!(window as unknown as Record<string, unknown>).fbq) {
        ensureFbqShared();
        console.log(`[${logPrefix} Meta] Injected fbevents.js`);
    } else if (isRealFbq()) {
        console.log(`[${logPrefix} Meta] Real fbq already loaded, reusing`);
    } else {
        console.log(`[${logPrefix} Meta] fbq stub present (from custom script), waiting for fbevents.js`);
    }
    return isRealFbq;
}
